import { Tag } from '../Tag';

function WantedTag() {
  return <Tag text="Wanted" textColor="GREY_DARK" bgColor="GREY_LIGHTER" />;
}

export { WantedTag };
